import { render, staticRenderFns } from "./LocalAudioControlButton.vue?vue&type=template&id=5cdeb6e2&scoped=true"
import script from "./LocalAudioControlButton.vue?vue&type=script&lang=js"
export * from "./LocalAudioControlButton.vue?vue&type=script&lang=js"
import style0 from "./LocalAudioControlButton.vue?vue&type=style&index=0&id=5cdeb6e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdeb6e2",
  null
  
)

export default component.exports